import { EventBus } from "../../../../static/js/event-bus.js";

import axios from "axios";

//按需加载
import { addRoamingPoint, editRoamingPoint } from "../../../../api/api";

export default {
  components: {},
  props: {},
  data() {
    return {
      customRoamingPoint_show: true,
      customRoamingPoint_submit_disabled: false,

      form: {
        id: "",
        pathName: "",
        pathId: 0,
        pointName: "1",
        title: "",
        position: "",
        heading: "",
        pitch: "",
        // roll:'',
        sort: 0,
        uid: "", //漫游点对象id
      },
      title: "新增",
      rules: {
        pointName: [
          {
            required: true,
            message: "请输入漫游点名称",
            trigger: "blur",
          },
        ],
        position: [
          {
            required: true,
            message: "右键单击地图，输入经度,维度,高程,航向角,俯仰角",
            trigger: "blur",
          },
        ],
      },
      dataArr: [],
      isEdit: false,
      prvJD: undefined,
      prvWD: undefined,
      prvGD: undefined,
      currHeading: undefined,
      currPitch: undefined,
      center: undefined,
      dftPointName: 1,
      oldPointName: "-1",
      isStopDrawPoint: true,
    };
  },
  mounted() {
    this.initFormData();
    this.center = this.$GLOBAL.map.getCameraView();
    this.currHeading = this.center.heading + "";
    this.currPitch = this.center.pitch + "";
    //漫游点功能
    if (!this.$GLOBAL.markDrawGraphicLayer2) {
      //alert(2);
      this.$GLOBAL.markDrawGraphicLayer2 = new mars3d.layer.GraphicLayer({
        hasEdit: true,
        isAutoEditing: true, //绘制完成后是否自动激活编辑
      });
      this.$GLOBAL.map.addLayer(this.$GLOBAL.markDrawGraphicLayer2);

      let that = this;
      this.$GLOBAL.markDrawGraphicLayer2.on(
        mars3d.EventType.editMovePoint,
        function(e) {
          //根据编辑对象的id找到对应漫游点列表里的数据项，对应进行编辑。
          //that.$parent.editMarkRecordByUid(e.graphic.uuid);

          var point = mars3d.LngLatPoint.fromCartesian(e.cartesian);
          point.format(); //经度、纬度、高度

          let currJD = point.lng;
          let currWD = point.lat;
          let currGD = point.alt;
          let cartesianXYZ = currJD + "," + currWD + "," + currGD;
          EventBus.$emit("updateCartesian2", {
            cartesianXYZ: cartesianXYZ,
            graphic: e.graphic,
          });
        }
      );
    }
    EventBus.$on("updateCartesian2", (param) => {
      //当漫游点点移动时，根据漫游点的id获取到漫游点的表单信息并显现在表单上，方便准确定位和编辑、更新等。

      this.form.position = param.cartesianXYZ;

      //根据编辑对象的id找到对应漫游点列表里的数据项，对应进行编辑。
      // this.editMarkRecordByUid(param.graphic.uuid);
      //alert(param.cartesianXYZ)
    });
  },
  methods: {
    onSubmit() {
      let that = this;
      if (!this.form.pathId) {
        //如果所属路径Id缺失了，则不予保存，直接关闭点位弹窗，避免提交一些路径Id为0的无效错误数据到后台数据库。
        that.$alert("漫游点信息数据缺失，请重新编辑。", "编辑失败", {
          confirmButtonText: "确定",
          type: "error",
          callback: (action) => {},
        });
        this.$parent.open_roaming_box = "";
        return false;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          //alert(1)
          /* 表单提交后2秒内不可重复点击 */
          this.customRoamingPoint_submit_disabled = true;
          let that = this;
          //console.log(this);
          setTimeout(function() {
            that.customRoamingPoint_submit_disabled = false;
          }, 600);

          let x, y, z, heading, pitch;
          if (this.form.position) {
            let tempArr = this.form.position.split(",");
            if (tempArr[0] !== "undefined") {
              x = tempArr[0];
            }
            if (tempArr[1] !== "undefined") {
              y = tempArr[1];
            }
            if (tempArr[2] !== "undefined") {
              z = tempArr[2];
            }
            if (tempArr[3] !== "undefined") {
              heading = tempArr[3];
            }
            if (tempArr[4] !== "undefined") {
              pitch = tempArr[4];
            }
          } else {
            x = "";
            y = "";
            z = "";
            heading = "";
            pitch = "";
          }
          // alert(this.form.pathId);
          // return false;
          //let center = this.$GLOBAL.map.getCameraView();
          let rpData = {
            projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
            bimRoamId: this.form.pathId,
            pointName: this.form.pointName,
            title: this.form.title,
            heading: heading, //center.heading+"",
            pitch: pitch, //center.pitch+"",
            // roll:"0",//roll正常都是0，所以这里就直接传0。
            sort: this.form.sort,
            x: x,
            y: y,
            z: z,
          };
          // console.log(JSON.parse(JSON.stringify(rpData)));
          // console.log(11111111111);
          // return false;
          if (this.isEdit) {
            //alert(2)
            rpData.id = this.form.id;
            editRoamingPoint(rpData).then((res) => {
              if (res.data.success && res.data.code === 204) {
                // 改为：直接通知父组件刷新数据
                that.$parent.initData();

                that.$notify({
                  title: "已成功更新漫游点信息。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert(
                  "修改漫游点信息保存失败了，请再试一次吧~",
                  "编辑失败",
                  {
                    confirmButtonText: "确定",
                    type: "error",
                    callback: (action) => {},
                  }
                );
              }
            });
          } else {
            addRoamingPoint(rpData).then((res) => {
              // console.log(JSON.parse(JSON.stringify(res)));
              // console.log(3333333333333333333);
              if (res.data.success && res.data.code === 204) {
                that.$parent.initData();

                that.$notify({
                  title: "已成功新增漫游点信息。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert("添加漫游点信息失败了，请再试一次吧~", "添加失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
            });
          }
          this.customRoamingPoint_click();
        }
      });
    },
    addRoamingPoint(pathName, pathId) {
      //fdata为目录选项数据。
      // console.log(pathName, pathId);
      if (pathName && pathId) {
        this.isEdit = false;
        this.title = "新增";
        this.initFormData();
        this.$refs.form.resetFields();
        this.form.pathName = pathName;
        this.form.pathId = pathId;
        this.bindMourseClick();
      } else {
        this.$parent.open_roaming_box = "";
        this.$alert("您选择的路径参数缺失了，请再试一次~", "友情提示", {
          confirmButtonText: "确定",
          type: "error",
          callback: (action) => {},
        });
      }
    },
    editMark(data, fdata) {
      //data为编辑数据，fdata为目录选项数据。
      this.form = data;
      this.data = data; //这个this.data是方便页面里的删除按钮传值的。
      this.isEdit = true;
      this.title = "编辑";
    },
    initCurrPosition(data) {
      if (data != undefined) {
        this.prvJD = data.x;
        this.prvWD = data.y;
        this.prvGD = data.z;

        if (isNaN(parseInt(data.pointName))) {
          this.dftPointName = parseInt(this.form.pointName);
        } else {
          this.dftPointName = parseInt(data.pointName) + 1;
          this.form.pointName = this.dftPointName + "";
        }
      }
    },
    initDefaultPointName() {
      this.dftPointName = 1;
    },
    initFormData(params) {
      if (params) {
        let position = "";
        if (
          params.x ||
          params.y ||
          params.z ||
          (params.x === 0 && params.y === 0 && params.z === 0)
        ) {
          position = params.x + "," + params.y + "," + params.z;
        }
        this.form = {
          id: params.id || "",
          pathName: params.pathName || "",
          pathId: params.pathId || 0,
          pointName: params.pointName || "",
          title: params.title || "",
          position: position,
          heading: params.heading || "",
          pitch: params.pitch || "",
          // roll:params.roll||'',
          sort: params.sort || 0,
          uid: params.uid || "", //漫游点对象id
        };
      } else {
        this.form = {
          id: "",
          pathName: "",
          pathId: 0,
          pointName: this.dftPointName + "",
          title: "",
          position: "",
          heading: "",
          pitch: "",
          // roll:'',
          sort: 0,
          uid: "", //漫游点对象id
        };
      }
    },
    deleteRoamingPoint() {
      if (this.data && this.data.id) {
        this.$parent.deleteMarkRecord(this.data);
      } else {
        //console.log(this.data);
        this.$alert("删除失败，因为发生了数据错误", "友情提示", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
      }
    },
    customRoamingPoint_click() {
      //alert("触发");
      this.$GLOBAL.map.setCursor(false);
      if (this.$GLOBAL.markDrawGraphicLayer2) {
        this.isStopDrawPoint = true;
        this.$GLOBAL.markDrawGraphicLayer2.stopDraw();
        this.$GLOBAL.markDrawGraphicLayer2.clear();
      }
      this.$refs.form.resetFields();
      this.$emit("customRoamingPoint_close");
    },
    roamingPoint_Clean() {
      //this.$GLOBAL.markDrawGraphicLayer2.clear();
      this.$parent.open_roaming_box = ""; //清除漫游点的时候先关闭新增漫游点表单，避免漫游点没了，信息还可以提交。
      this.$GLOBAL.markDrawGraphicLayer2.removeGraphic(
        this.$GLOBAL.markDrawGraphicLayerObj
      );
      //此处可以清除一下已上传的文件【因为漫游点并没有被保存】，但是this.data不能获取到信息？。
    },
    //图上拾取
    bindMourseClick(editMark) {
      this.$GLOBAL.map.setCursor(true);
      let that = this;
      // 	this.$GLOBAL.map.once(mars3d.EventType.click, function(event) {
      // 		that.$GLOBAL.map.setCursor(false);
      // 		var cartesian = event.cartesian;
      // 		var point = mars3d.LngLatPoint.fromCartesian(cartesian);
      // 		point.format(); //经度、纬度、高度

      // 		let currJD = point.lng;
      // 		let currWD = point.lat;
      // 		let currGD = point.alt;
      // 		console.log(currJD,currWD,currGD);
      // 		//end
      // 		// updateMarker();
      // 	});
      this.$GLOBAL.markDrawGraphicLayer2.unbindPopup(); //解绑右键菜单

      //绑定标绘相关事件监听(可以自行加相关代码实现业务需求，此处主要做示例)
      this.$GLOBAL.markDrawGraphicLayer2.on(
        mars3d.EventType.drawStart,
        function(e) {
          console.log("开始绘制", e);
        }
      );
      this.$GLOBAL.markDrawGraphicLayer2.on(
        mars3d.EventType.drawAddPoint,
        function(e) {
          console.log("绘制过程中增加了点", e);
        }
      );
      this.$GLOBAL.markDrawGraphicLayer2.on(
        mars3d.EventType.drawRemovePoint,
        function(e) {
          console.log("绘制过程中删除了点", e);
        }
      );

      this.$GLOBAL.markDrawGraphicLayer2.on(
        mars3d.EventType.drawCreated,
        function(e) {
          if (that.$parent.isStopDrawPoint || that.isStopDrawPoint) return;
          console.log("创建完成", e.graphic._position_draw);
          var point = mars3d.LngLatPoint.fromCartesian(
            e.graphic._position_draw
          );
          point.format(); //经度、纬度、高度

          let currJD = point.lng;
          let currWD = point.lat;
          let currGD = point.alt;
          if (
            that.prvJD != undefined &&
            that.prvWD != undefined &&
            that.prvGD != undefined &&
            that.prvJD != currJD &&
            that.prvWD != currWD &&
            that.prvGD != currGD
          ) {
            let pointA = new Cesium.Cartesian3(
              parseFloat(that.prvJD),
              parseFloat(that.prvWD),
              parseFloat(that.prvGD)
            );
            let pointB = new Cesium.Cartesian3(currJD, currWD, currGD);
            let direction = mars3d.PointUtil.getHeadingPitchRollForLine(
              pointA,
              pointB
            );
            that.currHeading = direction.heading + 90 + "";
            that.currPitch = "-30";
          }
          let cartesianXYZ =
            currJD +
            "," +
            currWD +
            "," +
            currGD +
            "," +
            that.currHeading +
            "," +
            that.currPitch;
          EventBus.$emit("updateCartesian2", {
            cartesianXYZ: cartesianXYZ,
            graphic: e.graphic,
          });
          let fIconUrl =
            "/img/marker/mark" +
            that.$GLOBAL.default_markIconColor.slice(1) +
            ".png";
          let tempGL = that.$GLOBAL.markDrawGraphicLayer2.startDraw({
            type: "billboard",
            style: {
              image: fIconUrl,
              horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
              verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
              label: {
                //不需要文字时，去掉label配置即可
                //text: "可以同时支持文字",
                text: that.form.name,
                font_size: 26,
                font_family: "黑体",
                color: that.$GLOBAL.default_markIconColor,
                outline: true,
                // outlineColor: "#000000",
                pixelOffsetY: -66,
                visibleDepth: false,
              },
              visibleDepth: false,
            },
          });
          that.$GLOBAL.markDrawGraphicLayerObj = tempGL;
          that.form.uid = tempGL._id;

          let rpData = {
            projectId: parseInt(window.sessionStorage.getItem("nowProjectId")),
            bimRoamId: that.form.pathId,
            pointName: that.form.pointName,
            title: that.form.title,
            heading: that.currHeading, //center.heading+"",
            pitch: that.currPitch, //center.pitch+"",
            // roll:"0",//roll正常都是0，所以这里就直接传0。
            sort: that.form.sort,
            x: currJD,
            y: currWD,
            z: currGD,
          };
          if (that.form.pointName != that.oldPointName) {
            addRoamingPoint(rpData).then((res) => {
              if (res.data.success && res.data.code === 204) {
                that.$parent.initData();

                that.$notify({
                  title: "已成功新增漫游点信息。",
                  message: "",
                  type: "success",
                  duration: 960,
                  offset: 320,
                });
              } else {
                that.$alert("添加漫游点信息失败了，请再试一次吧~", "添加失败", {
                  confirmButtonText: "确定",
                  type: "error",
                  callback: (action) => {},
                });
              }
            });
          }
          that.oldPointName = that.form.pointName;
        }
      );
      this.$GLOBAL.markDrawGraphicLayer2.on(
        mars3d.EventType.editStart,
        function(e) {
          console.log("开始编辑", e);
        }
      );
      this.$GLOBAL.markDrawGraphicLayer2.on(
        mars3d.EventType.editRemovePoint,
        function(e) {
          console.log("编辑删除了点", e);
        }
      );
      this.$GLOBAL.markDrawGraphicLayer2.on(mars3d.EventType.editStop, function(
        e
      ) {
        console.log("停止编辑", e);
      });
      this.$GLOBAL.markDrawGraphicLayer2.on(
        mars3d.EventType.removeGraphic,
        function(e) {
          console.log("删除了对象", e);
        }
      );

      if (!editMark) {
        let fIconUrl =
          "/img/marker/mark" +
          this.$GLOBAL.default_markIconColor.slice(1) +
          ".png";
        let tempGL = this.$GLOBAL.markDrawGraphicLayer2.startDraw({
          type: "billboard",
          style: {
            image: fIconUrl,
            horizontalOrigin: Cesium.HorizontalOrigin.CENTER,
            verticalOrigin: Cesium.VerticalOrigin.BOTTOM,
            label: {
              //不需要文字时，去掉label配置即可
              //text: "可以同时支持文字",
              text: this.form.name,
              font_size: 26,
              font_family: "黑体",
              color: this.$GLOBAL.default_markIconColor,
              outline: true,
              // outlineColor: "#000000",
              pixelOffsetY: -66,
              visibleDepth: false,
            },
            visibleDepth: false,
          },
        });
        this.$GLOBAL.markDrawGraphicLayerObj = tempGL;
        this.form.uid = tempGL._id;
        // console.log(77777777777777777777);
        // console.log(tempGL);
        // console.log(JSON.parse(JSON.stringify(this.form)));
      }

      // this.$GLOBAL.markDrawGraphicLayerArray.push(tempGL);
      // console.log(this.$GLOBAL.markDrawGraphicLayerArray);
      // console.log(2222222222222222222222);
    },
    pointNameChange() {
      // alert('触发！');
      // console.log(77777777777777777777);
      // console.log(this.$GLOBAL.markDrawGraphicLayerObj);
      this.$GLOBAL.markDrawGraphicLayerObj.setOptions({
        style: {
          label: {
            text: this.form.pointName,
          },
        },
      });
    },
  },
  watch: {},
};
//console.log(localStorage.getItem(ColorPicker));
